var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.carts, function (cart, index) {
    return [_c('cart-list-item', {
      key: index,
      on: {
        "remove": function remove($event) {
          return _vm.carts.splice(index, 1);
        }
      },
      model: {
        value: _vm.carts[index],
        callback: function callback($$v) {
          _vm.$set(_vm.carts, index, $$v);
        },
        expression: "carts[index]"
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }